/** Alias in App → `/contattaci` con stessa query string. */
export const DEFAULT_PUBLIC_PROPOSAL_CTA_BASE = '/contatti';

const CTA_BASE_PATHS_DEFAULT = new Set([
  DEFAULT_PUBLIC_PROPOSAL_CTA_BASE,
  '/contattaci',
]);

export function buildDefaultPublicProposalCtaUrl(slug) {
  const s = String(slug ?? '').trim();
  if (!s) return '';
  return `${DEFAULT_PUBLIC_PROPOSAL_CTA_BASE}?proposta=${encodeURIComponent(s)}`;
}

export function resolvePublicProposalCtaUrl(proposal = {}) {
  return buildDefaultPublicProposalCtaUrl(proposal.slug);
}

export function isStoredCtaUrlCustom(storedUrl, slug) {
  const stored = String(storedUrl ?? '').trim();
  if (!stored) return false;
  const slugTrim = String(slug ?? '').trim();
  const def = buildDefaultPublicProposalCtaUrl(slugTrim);
  if (def && stored === def) return false;
  try {
    const u = new URL(stored, 'https://placeholder.local');
    if (CTA_BASE_PATHS_DEFAULT.has(u.pathname)) {
      const p = u.searchParams.get('proposta');
      if (p && slugTrim && decodeURIComponent(p) === slugTrim) return false;
    }
  } catch {
    /* ignore */
  }
  return true;
}
